import React from "react";


// Repère d'environnement (REACT_APP_NODE_ENV) : hors production, un badge à
// côté du logo dit où l'on est, sans toucher à la couleur du menu. Rien en
// production ni quand la variable est absente.
const LIBELLES = {
  development: { libelle: "Dév", court: "DEV" },
  dev: { libelle: "Dév", court: "DEV" },
  staging: { libelle: "Staging", court: "STG" },
  recette: { libelle: "Recette", court: "REC" },
  preprod: { libelle: "Préprod", court: "PRÉ" },
  test: { libelle: "Test", court: "TST" },
};

export function badgeEnvironnement(valeur) {
  const cle = String(valeur || "").trim().toLowerCase();
  if (!cle || cle === "production") return null;
  const connu = LIBELLES[cle];
  if (connu) return { valeur: cle, ...connu };
  const libelle = cle.charAt(0).toUpperCase() + cle.slice(1);
  return { valeur: cle, libelle, court: cle.slice(0, 3).toUpperCase() };
}

// Badge du menu : libellé complet à côté du logo, abrégé dans le rail.
export const BadgeEnvironnement = ({ badge, abrege = false, className = "" }) =>
  badge ? (
    <span className={`badge-env ${className}`.trim()} title={`Environnement : ${badge.valeur}`}>
      <span aria-hidden="true">{abrege ? badge.court : badge.libelle}</span>
      <span className="sr-only">Environnement : {badge.libelle}</span>
    </span>
  ) : null;
